import Vue from 'vue';
import Vuex from 'vuex';
import { createModule } from 'vuex-toast';
import 'vuex-toast/dist/vuex-toast.css';
import { persistedState, persistedCookieState } from './persistedState';
import auth from './auth';
import ui from './ui';
import loader from './loader';
import appointment from './appointment';
import appointmentTypes from './appointment-types';
import business from './business';
import booking from './booking';
import notifications from './notifications';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    loader,
    ui,
    auth,
    toast: createModule({
      dismissInterval: 4000,
    }),
    appointment,
    appointmentTypes,
    business,
    booking,
    notifications,
  },
  plugins: [persistedState, persistedCookieState],
});



// WEBPACK FOOTER //
// ./src/store/index.js